import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import { removeNotification } from "./../../redux/actions/notificationActions";

const styles = theme => ({
  close: {
    padding: theme.spacing.unit / 2
  },
  snackbar: {
    margin: theme.spacing.unit
  }
});

class Notification extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.props.notifications.map(notification => (
          <Snackbar
            key={notification.id}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={true}
            ContentProps={{
              "aria-describedby": "message-id"
            }}
            message={<span id={notification.id}>{notification.message}</span>}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={() =>
                  this.props.actions.removeNotification({
                    notificationId: notification.id
                  })
                }
              >
                <CloseIcon />
              </IconButton>
            ]}
          />
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  notifications: state.notifications
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ removeNotification }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Notification));



// WEBPACK FOOTER //
// ./src/components/common/Notification.js